import * as React from 'react'
import * as CategoryItemStyles from './CategoryListItem.style'
import CategoryItem from '../../../Home/components/HomeItemListItem/HomeItemListItem'
import HomeType from '../../../Home/types/HomeType'
import {HttpServer} from '@/services/server'
import {getJsonFromUrl} from '@/utils/tools'

interface CategoryListItemProp {
    categoryId: number,
    content: {
        has_more: boolean,
        ret: HomeType.Content[]
    },
}

interface CategoryListItemState {
    liveData: HomeType.Content[],
    has_more: boolean,
    pageNum: number,
    categoryId: number,
    loadingMore: boolean
}

export default class CategoryListItem extends React.Component <CategoryListItemProp, CategoryListItemState> {
    public state = {
        liveData: [],
        has_more: true,
        pageNum: 1,
        categoryId: 0,
        loadingMore: false
    }
    public componentDidMount() {
        if (!getJsonFromUrl().recommend) {
            this.setState({
                categoryId: getJsonFromUrl().id
            })
        }
        this.setState({
            liveData: this.props.content.ret,
            has_more: this.props.content.has_more
        })
    }
    public componentWillReceiveProps(nextProps: any) {
        if (nextProps.content) {
            this.setState({
                liveData: nextProps.content.ret,
                has_more:  nextProps.content.has_more,
                categoryId: nextProps.categoryId,
                pageNum: 1
            })
        }
    }
    public loadingMore = () => {
        this.setState({
            pageNum: ++this.state.pageNum,
            loadingMore: true
        })
        const params = {
            category: this.state.categoryId,
            p: this.state.pageNum
        }
        HttpServer.getCategoryListItem(params).then((res) => {
            this.setState({
                liveData: this.state.liveData.concat(res.data.data.ret),
                has_more: res.data.data.has_more,
                loadingMore: false
            })
        })
    }
    public render() {
        return (
            <div className={CategoryItemStyles.CategoryListItem}>
                {this.state.liveData.length > 0 &&
                <div className={CategoryItemStyles.titleName}>正在直播</div>}
                {this.state.liveData.map((v: HomeType.Content) => (
                    <CategoryItem content={v} key={v.id}/>
                  ))
                }
                {this.state.has_more &&
                    <div className={CategoryItemStyles.findMore} onClick={this.loadingMore}>
                        查看更多
                        <img src="https://static-1253442168.image.myqcloud.com/picture/7931794_3df67f7c744f109b88fef872e98f6dc7.jpg" alt=""/>
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryListItem/CategoryListItem.tsx